
import { mapState } from 'vuex'
export default {
    data() {
        return {
            cryptoWallets: [],
        }
    },
    computed: {
        ...mapState({
            loading: (state) => state.themes['player-bank'].loading,
            playerCryptoWallets: (state) =>
                state.themes['player-bank'].playerCryptoWallets,
        }),
    },
    watch: {
        playerCryptoWallets(value) {
            if (value?.length > 0) {
                this.cryptoWallets = [...value, { id: null }]
            }
        },
    },
    mounted() {
        this.$store.dispatch('themes/player-bank/playerCryptoWallet')
    },
    methods: {
        onEditCryptoAccount(item) {
            this.$router.push('/payment-methods/edit/crypto/' + item.id)
        },
    },
}
